export const DEFAULT_EXCLUDE_TEAM = true;
